import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Badge from "./Badge";

const BadgeCard = ({ badge }) => {
  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Badge badge={badge} />
      </Grid>

      <Grid item>
        <Typography>{badge.fileName}</Typography>
      </Grid>
    </Grid>
  );
};

export default BadgeCard;
